<template>
  <div class="proposal-details-modal-legend">
    <p>Each user, regardless of the experiment color, is obliged to follow the guidelines specified by the Safety
      Group for the current application/proposal.</p>
    <p>Additionally for each experiment color the common rules must be fulfilled:</p>
    <ol>
      <li>
        <strong class="text-success">Green (ACCEPTED) experiment</strong>: an experiment that does not require any
        special safety restrictions.
      </li>
      <li>
        <strong class="text-warning">Yellow (RESTRICTED) experiment</strong>: an experiment that requires special
        restrictions.
        <ul>
          <li>The experiment can start only on working days during working hours (8:00 AM – 4:00 PM).</li>
          <li>Safety Group verifies the guidelines before the experiment and grants permission to start the
            experiment.
          </li>
        </ul>
      </li>
      <li>
        <strong class="custom-text-danger">Red (HIGHLY RESTRICTED) experiment</strong>: an experiment that requires special
        restrictions.
        <ul>
          <li>The experiment can start and finish only on working days during working hours (8:00 AM – 4:00 PM).</li>
          <li>
            The main Proposer will be asked to complete a safety form, which will be sent well in advance to identify
            potential risks. The safety form must include guidance on actions to take in case of an accident associated
            with identified hazards. The completed form will be available at the beamline for the entire duration of the
            experiment for reference.
          </li>
          <li>
            Safety Group verifies all guidelines before the experiment and gives permission to start the experiment.
            After completion, the Safety officer will verify the infrastructure status and officially close the
            experiment.
          </li>
          <li>
            During the experiment, at least one member of the experimental group must be present at the beamline.
            This means that experiment can be performed only under constant supervision (24 h per day) by members
            of the experimental group.
          </li>
        </ul>
      </li>
      <li>
        <strong class="text-dark">Black (REJECTED) experiment</strong>: an experiment rejected from Safety or Radiation
        issues.
      </li>
    </ol>
  </div>
</template>

<script>
  export default { name: 'ProposalDetailsModalLegend' };
</script>

<style scoped>
  .proposal-details-modal-legend * {
    text-align: justify;
  }

  ul {
    list-style-type: disc;
  }
</style>
